import React from "react";
import { Search } from "../FunctionComponents/Search";

export const SearchBar = () => {
  return (
    <>
      <Search/>
    </>
  );
}